import React from 'react';
import PropTypes from 'prop-types';
import { map, is, identity, addIndex } from 'ramda';
import { injectIntl, intlShape } from 'react-intl';

import NoEntriesText from 'routes/Documents/components/NoEntriesText';
import { getLatestFinishedCommitData } from 'lib/documentHandling';

const normalize = map(d => ({ ...d, content: getLatestFinishedCommitData(d) }));

const HistoryContainer = ({ mapper, documents, emptyText, intl, sorter = identity }) => {
  if (is(Array, documents) && documents.length > 0) {
    return <div>{addIndex(map)((d, i) => mapper(d, intl, i), sorter(normalize(documents)))}</div>;
  } else if (is(Array, documents) && documents.length === 0 && emptyText) {
    return (
      <div>
        <NoEntriesText emptyText={emptyText} />
      </div>
    );
  }
  return null;
};

HistoryContainer.propTypes = {
  mapper: PropTypes.func.isRequired,
  documents: PropTypes.array,
  emptyText: PropTypes.string,
  sorter: PropTypes.func,
  intl: intlShape,
};

export default injectIntl(HistoryContainer);
